// Desc: get url string from filters object using native APIs
const getUrlString = (filters: Record<string, any>): string => {
  return new URLSearchParams(filters).toString();
};

export default getUrlString;
